goog.provide("shadow.js.shim.module$src$svg$inform$plus_svg$default");
shadow.js.shim.module$src$svg$inform$plus_svg$default = shadow.js.shim.module$src$svg$inform$plus_svg.default;
